import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class SeguroService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getSeguros(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguro' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSeguro(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguro/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getSegurosByUsuario(usuario) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguro/usuario/' + usuario)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaSeguro(data) {
		
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/seguro', {
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_id: data.veiculo_id,
				seguro_apolice: data.seguro_apolice,
				seguro_ci: data.seguro_ci,
				seguro_valor: data.seguro_valor,
				seguro_rateio: data.seguro_rateio,
				seguro_data_contrato: data.seguro_data_contrato,
				seguro_vigencia: data.seguro_vigencia,
				seguradora_id: data.seguradora_id,
				corretora_id: data.corretora_id,
				seguro_descricao: data.seguro_descricao,
				seguro_solicitante: data.seguro_solicitante,
				seguro_aprovador : data.seguro_aprovador ,
				seguro_arq_documento: data.seguro_arq_documento,
				seguro_arq_apolice: data.seguro_arq_apolice,
				seguro_arq_documento_nome: data.seguro_arq_documento_nome,
				seguro_arq_apolice_nome: data.seguro_arq_apolice_nome,
				seguro_arq_documento_arquivo: data.seguro_arq_documento_arquivo,
				seguro_arq_apolice_arquivo: data.seguro_arq_apolice_arquivo
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaSeguro(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/seguro/' + data.seguro_id, {
				usuario_id: data.usuario_id,
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				veiculo_id: data.veiculo_id,
				seguro_apolice: data.seguro_apolice,
				seguro_ci: data.seguro_ci,
				seguro_valor: data.seguro_valor,
				seguro_rateio: data.seguro_rateio,
				seguro_data_contrato: data.seguro_data_contrato,
				seguro_vigencia: data.seguro_vigencia,
				seguradora_id: data.seguradora_id,
				corretora_id: data.corretora_id,
				seguro_descricao: data.seguro_descricao,
				seguro_solicitante: data.seguro_solicitante,
				seguro_aprovador : data.seguro_aprovador ,
				seguro_arq_documento: data.seguro_arq_documento,
				seguro_arq_apolice: data.seguro_arq_apolice,
				seguro_arq_documento_nome: data.seguro_arq_documento_nome,
				seguro_arq_apolice_nome: data.seguro_arq_apolice_nome,
				seguro_arq_documento_arquivo: data.seguro_arq_documento_arquivo,
				seguro_arq_apolice_arquivo: data.seguro_arq_apolice_arquivo				
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaSeguro(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/seguro/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	sendFile(data){
		this.http.post(this.url + '/seguro', data)
		.subscribe((response) => {
			console.log('response received is ', response);
		})
	}


	getSeguroArquivo(id,col){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/seguro/getArquivo/' + id + '/' + col)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

}
